import Analytics from "@/system/Analytics";
import { OnboardingEvents } from "@/system/Analytics/events/OnboardingEvents";
import { API } from "../Client";


export namespace StudentService {
  export async function resendVerificationEmail(userId: string, token: string): Promise<void> {
    try {
      Analytics.track(OnboardingEvents.RESEND_VERIFICATION_EMAIL, { userId });
      await API.post(`/verification/resend`, { token, deviceType: 'web' });
    } catch (error: Error | any) {
      Analytics.track(OnboardingEvents.RESEND_VERIFICATION_EMAIL_ERROR, { userId });
      throw new Error(error?.response?.data?.message ?? error?.message ?? 'Failed to resend verification email');
    }
  }

  export async function getVerificationStatus(): Promise<any> {
    try {
      const { data } = await API.get('/verification/status')
      return data;
    } catch (error: Error | any) {
      throw new Error(error.message);
    }
  }
}